const initialState = {
  loading: false,
  id: null,
  content: null,
  type: null,
  createNew: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'selectLesson':
      return {
        ...state,
        ...action.details,
        id: action.id,
        content: action.content
      };

    case 'UPDATE_LESSON': {
      return {
        ...state,
        content: action.content,
        type: action.contentType
      };
    }
    case 'REMOVE_CONTENT': {
      return {
        ...state,
        content: null
      };
    }

    case 'updateSelectedLesson': {
      return {
        ...state,
        id: action.id,
        createNew: action.createNew
      };
    }

    case 'clearLesson': {
      return initialState;
    }
    default:
      return state;
  }
};

export default reducer;
